import { Component, Input } from '@angular/core';
import { LogTypeEnum } from '../../enum/log-type.enum';

@Component({
  selector: 'app-log-type-badge',
  templateUrl: './log-type-badge.component.html',
  styleUrls: ['./log-type-badge.component.css']
})
export class LogTypeBadgeComponent {
  @Input() value: string;

  logTypeEnum = LogTypeEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
